import React from "react";
import {useTranslation} from "react-i18next";

import ValTab from "./valtab";

function Items({data, onUpdate, simplified, dangerous, axis}) {
    const {t} = useTranslation();

    var headerStyle = {width: 60, maxWidth: 60, padding: 3, fontSize: "60%", align: "center"};

    return <ValTab title={t("Items")}
            columns={[
                    {title: t("Count"), field: "count", type: "numeric", min: 1, initialEditValue: 1, width: 60, headerStyle: headerStyle},
                    {title: t("Length"), field: "depth", type: "numeric", min: 1, max: 3000, width: 60, headerStyle: headerStyle},
                    {title: t("Width"), field: "width", type: "numeric", min: 1, max: 3000, width: 60, headerStyle: headerStyle},
                    {title: t("Height"), field: "height", type: "numeric", min: 1, max: 3000, width: 60, headerStyle: headerStyle},
                    {title: t("Weight"), field: "weight", type: "numeric", hidden: simplified, width: 60, headerStyle: headerStyle},
                    {title: t("Class"), field: "itemClass", type: "numeric", hidden: simplified, width: 60, headerStyle: headerStyle},
                    {title: t("Vertical"), field: "vertical", type: "boolean", initialEditValue: true, hidden: simplified, width: 60, headerStyle: headerStyle},
                    {title: t("Unload Prio"), field:"unloadPrio", type: "numeric", hidden: !axis, width: 60, headerStyle: headerStyle},
                    {title: t("Risk Points"), field: "riskPoints", type: "numeric", hidden: !dangerous, width: 60, headerStyle: headerStyle},
                    {title: t("Risk Types"), field: "riskTypes", type: "string", hidden: !dangerous, width: 60, headerStyle: headerStyle},
                    {title: t("Remaining"), field: "remaining", editable:"never", width: 60, headerStyle: headerStyle}
                    ]}
            data={data}
            onUpdate={onUpdate}
            />;

    }

export default Items;
